// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5d598c91","453":"c5e6e5d2","455":"aa8e7f19","857":"3eab8556","977":"5f60efc0"}[chunkId] + ".chunk.js";
};